@if (collectionDetail && collectionDetail.name) {
  <!--================================= Banner Section Start =================================-->
  <div class="banner-section-main banner-section-cms-page">
    <div class="banner-section overlay-container">
      @if (collectionDetail.image && collectionDetail.image !== '') {
        <img class="bg-img"
             [ngSrc]="CommonConstants.IMAGE_KIT_ENDPOINT + '/' + collectionDetail.image + CommonConstants.IMAGE_SIZE_2268_X_940"
             width="1820" height="935"
             [alt]="collectionDetail.name">
      } @else {
        <img class="bg-img"
             [src]="noImage"
             width="1820" height="935"
             [alt]="collectionDetail.name || 'No Image'">
      }
      <div class="banner-section-content">
        @if (collectionDetail.name) {
          <p class="banner-sub-title">
            <span [routerLink]="['/'+ productType ]" class="disabled">
              {{ productType == CommonConstants.FLOORING_TYPE_NAME ? 'Flooring' : 'Walling' }}
            </span>
            /
            @if (selectedCategory) {
              <a [routerLink]="['/'+ productType + '/' + collectionDetail.slug]"
                 class="disabled">
                {{ collectionDetail.name }}
              </a>
              /
              <span>{{ categoryList[0]?.name }}</span>
            } @else {
              <span>{{ collectionDetail.name }}</span>
            }
          </p>
          <h1 class="page-title">{{ selectedCategory ? categoryList[0]?.name : collectionDetail.name }}</h1>
        }
      </div>
    </div>
  </div>
  <!--================================= Banner Section End ===================================-->
    <!--============================== description Section Start ===============================-->
  @if (!selectedCategory) {
    <div class="description-section">
      <p class="section-content">{{ collectionDetail.description }}</p>
    </div>
  }
  <!--================================ description Section End ===============================-->
    <!--================================ Battens item Section Start ============================-->
  <div class="battens-item-section">
    <div class="battens-item-section-inner">
      <!-- Loop through each category in the categoryList -->
      @for (category of categoryList; track category; let idx = $index) {
        @if (category.products && category.products.length > 0) {
          <h2 class="section-title clickable"><a [routerLink]="redirectWithCategory(category.name)">{{ category.name }}</a></h2>
          <app-product-list [products]="category.products" [isProductListPage]="true" [categoryIndex]="idx"/>
        }
      }
    </div>
  </div>
  <!--================================ Battens item Section End ==============================-->
    <!--================================ FAQs Section Start ==============================-->
  @if (!selectedCategory) {
    <div class="battens-item-section pt-0">
      <app-faqs [collectionID]="collectionDetail.id" [title]="'FAQs'" [faqPage]="false"
      ></app-faqs>
    </div>
  }
  <!--================================ FAQs Section End ==============================-->
}
